import { Component } from 'react';
import './index.scss';
import { Footer } from '../../../components';
import HeaderContainer from '../../LandingPage/HeaderContainer';
import { MetaTags } from 'react-meta-tags';

class RefundPolicy extends Component{

    constructor(props){
        super(props);
        this.state = {packs : []}
    }

    componentDidMount(){

    }

    render = () => {
     
        return (
            <div className='policies-container'>   
                <MetaTags>
                    <title>Vertate | Refund Policy</title>
                    <meta name="description" content="Refund Policy" />
                    <meta property="og:title" content="Vertate" />
                </MetaTags>
                <HeaderContainer/>
                <div className='text-container'>
                    <h1 className='text-primary text-center'>Refund Policy</h1>
                    <h4 className='text-grey'>
                        For software products
                        We have a 1-day return policy in Discount Coupon, which means you have 1 day after receiving your item to request a return of the purchase price (not the original value of the digital product) via a discount code in the exact value of the purchase price to be used in the website for 6 months.

                        To be eligible for a return, you must explain the reason why the product didn´t mean your expectations as well as provide reasonable feedback on how to improve future products.
                        This information shall be sent via email, and should have no less than 100 words on the return reasons. You’ll also need the receipt or proof of purchase.
                    </h4>
                    <h4 className='text-grey'>

                        For hardware products

                        To start a return, you can contact us at team@vertate.com. Please note that returns will need to be sent to the following address: 

                        If your return is accepted, we’ll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted.

                        You can always contact us for any return question at team@vertate.com.
  </h4>
                    <h4 className='text-grey'>

                        Damages and issues
                        Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.

  </h4>
                    <h4 className='text-grey'>
                        Exceptions / non-returnable items
                        Certain types of items cannot be returned, like perishable goods (such as food, flowers, or plants), custom products (such as special orders or personalized items), and personal care goods (such as beauty products). We also do not accept returns for hazardous materials, flammable liquids, or gases. Please get in touch if you have questions or concerns about your specific item.

                        Unfortunately, we cannot accept returns on sale items or gift cards.
  </h4>
                    <h4 className='text-grey'>

                        Exchanges
                        The fastest way to ensure you get what you want is to return the item you have, and once the return is accepted, make a separate purchase for the new item.
  </h4>
                    <h4 className='text-grey'>

                        European Union 14 day cooling off period
                        Notwithstanding the above, if the merchandise is being shipped into the European Union, you have the right to cancel or return your order within 14 days, for any reason and without a justification. As above, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase.
  </h4>
                    <h4 className='text-grey'>

                        Refunds
                        We will notify you once we’ve received and inspected your return, and let you know if the refund was approved or not. If approved, you’ll be automatically refunded on your original payment method within 10 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too.
                        If more than 15 business days have passed since we’ve approved your return, please contact us at team@vertate.com, Vertate OU.
                </h4>    </div>
                <Footer width={100} full={true}/>
            </div>
            )
        }
    
}

export default RefundPolicy;